import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyChpVrlGfW6q6vtCktiGnOqUa117JnnQrI',
  authDomain: 'adsunorm.firebaseapp.com',
  projectId: 'adsunorm',
  storageBucket: 'adsunorm.appspot.com',
  messagingSenderId: '624156601932',
  appId: '1:624156601932:web:3ecf16c3b3687a0bfb0ee9',
  measurementId: 'G-WTN2EY8366'

  //

  // apiKey: 'AIzaSyBhFdefFn1nGSZg2TTD1akI9fyPXxKif1M',
  // authDomain: 'xekhach-config-variance.firebaseapp.com',
  // projectId: 'xekhach-config-variance',
  // storageBucket: 'xekhach-config-variance.appspot.com',
  // messagingSenderId: '417579103396',
  // appId: '1:417579103396:web:11fea347b5a271f0d3a231',
};

initializeApp(firebaseConfig);

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const getMessagingToken = () => {
  return getToken(messaging, {
    vapidKey: 'BJ2kUjT3oKDwcoZvYCBI2SbBhi1EZJ6fFzJVgoC7Av_zN93T2OKG85V417m4XMC0rKQjfKheNdPSmsTyzy4whkU'
    // vapidKey: 'BNAyxYhhHvD0nlkx6iiczGtpSmL6B5bZVnlMRMLbGlo2DO4U0Pqhdjw1cbjqm-hqiH4PS9kTqxG_PZg1FXwwvDA',
  })
    .then(currentToken => {
      console.log({ currentToken });
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
        return currentToken;
      } else {
        console.log('No registration token available. Request permission to generate one.');
        // shows on the UI that permission is required
      }
    })
    .catch(err => {
      console.log('An error occurred while retrieving token. ', err);
      // catch error while creating client token
    });
};

export const onMessageListener = () =>
  new Promise(resolve =>
    onMessage(messaging, payload => {
      resolve(payload);
    })
  );
